import { Link } from "react-router-dom";
import { Clock, Star } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useDict } from "@/i18n/dict";

const Stars = ({ rating }) => (
  <span className="inline-flex items-center gap-0.5 text-[color:var(--mango)]">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={11}
        fill={i <= Math.round(rating) ? "currentColor" : "none"}
        strokeWidth={1.5}
      />
    ))}
  </span>
);

export default function RecipeCard({ recipe, testId, compact = false }) {
  const { lang } = useLang();
  const t = useDict(lang);
  const title = recipe.title[lang] || recipe.title.fr;
  const summary = recipe.summary?.[lang] || recipe.summary?.fr || "";
  const primaryTag = recipe.tags?.[0];
  return (
    <Link to={`/recipes/${recipe.slug}`} data-testid={testId} className="recipe-card group block">
      <div className="recipe-card-img">
        <img src={recipe.image} alt={title} loading="lazy" />
        {primaryTag && (
          <span className="absolute top-3 left-3 bg-[var(--bg)] text-[color:var(--ink)] text-[10px] uppercase tracking-[0.18em] px-2.5 py-1 rounded-full font-medium">
            {t.tagLabels?.[primaryTag] || primaryTag}
          </span>
        )}
      </div>
      <div className="pt-4 pb-2">
        <p className="eyebrow mb-2">{recipe.country} · {t.types[recipe.type] || recipe.type}</p>
        <h3 className={`font-serif-display ${compact ? "text-xl" : "text-2xl"} leading-tight mb-2 group-hover:text-[color:var(--navy)] transition-colors`}>{title}</h3>
        {!compact && <p className="text-sm text-[color:var(--ink-2)] line-clamp-2 mb-3">{summary}</p>}
        <div className="flex items-center gap-3 text-xs text-[color:var(--ink-3)]">
          <span className="inline-flex items-center gap-1.5">
            <Stars rating={recipe.rating || 4.7} />
            <span className="text-[color:var(--ink-2)] font-medium">{(recipe.rating || 4.7).toFixed(1)}</span>
          </span>
          <span>·</span>
          <span className="inline-flex items-center gap-1"><Clock size={12} /> {recipe.time_minutes} {t.recipes.minutes}</span>
        </div>
      </div>
    </Link>
  );
}
